import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { SlideadjustmentunitpriceBasicInfo } from 'sg-api';
import { FormGroupDirective, UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';

/**
 * スライド調整単価登録画面(基本情報)
 * @exports
 * @class Sgkc032dSlideTankaBasicInfoComponent
 * @implements {OnInit,OnDestroy}
 */
@Component({
    selector: 'app-sgkc032d-slide-tanka-basic-info',
    templateUrl: './sgkc032d-slide-tanka-basic-info.component.html',
    styleUrl: './sgkc032d-slide-tanka-basic-info.component.scss'
})
export class Sgkc032dSlideTankaBasicInfoComponent implements OnInit, OnDestroy {
    /** 画面モード */
    @Input() mode: string
    /** スライド調整単価登録基本情報 */
    @Input() slideadjustmentunitpriceBasicInfo: SlideadjustmentunitpriceBasicInfo;

    /** スライド調整単価表名称 */
    slideadjustmentunitpriceAname = this.fb.control({ value: '', disabled: true });
    /** スライド調整単価表説明 */
    slideadjustmentunitpriceExplanation = this.fb.control({ value: '', disabled: true });
    /** 登録単位 */
    registrationunit = this.fb.control({ value: '', disabled: true });
    /** 会社名 */
    companyname = this.fb.control({ value: '', disabled: true });
    /** エネルギー種別名称 */
    energyClsname = this.fb.control({ value: '', disabled: true });
    /** ＬＰ販売形態名称 */
    lpSalfrmAname = this.fb.control({ value: '', disabled: true });
    /** スライド調整単価メモ */
    slideadjustmentunitpriceMemo = this.fb.control({ value: '', disabled: true });
    /** 単価基本情報保持Form */
    slideTankatableBasicInfoForm: UntypedFormGroup = this.fb.group({
        slideadjustmentunitpriceAname: this.slideadjustmentunitpriceAname,
        slideadjustmentunitpriceExplanation: this.slideadjustmentunitpriceExplanation,
        registrationunit: this.registrationunit,
        companyname: this.companyname,
        energyClsname: this.energyClsname,
        lpSalfrmAname: this.lpSalfrmAname,
        slideadjustmentunitpriceMemo: this.slideadjustmentunitpriceMemo,
    });
    /** 親コンポーネント保持領域 */
    parentForm: UntypedFormGroup;

    /** 
     * コンストラクタ
     * @param {FormGroupDirective} parent 
     * @param {UntypedFormBuilder} fb 
     * @memberof Sgkc032dTankaTableBasicInfoComponent
     */
    constructor(
        private parent: FormGroupDirective,
        private fb: UntypedFormBuilder,) {
    }

    /** 
     * 初期処理
     * @memberof Sgkc032dTankaTableBasicInfoComponent
     */
    ngOnInit(): void {
        this.parentForm = this.parent.form;
        this.parentForm.addControl('slideTankatableBasicInfoForm', this.slideTankatableBasicInfoForm);
        // スライド調整単価表基本情報FormGroupに初期値を設定
        this.slideTankatableBasicInfoForm.controls['slideadjustmentunitpriceAname'].setValue(this.slideadjustmentunitpriceBasicInfo.slideadjustmentunitpriceAname);
        this.slideTankatableBasicInfoForm.controls['slideadjustmentunitpriceExplanation'].setValue(this.slideadjustmentunitpriceBasicInfo.slideadjustmentunitpriceExplanation);
        this.slideTankatableBasicInfoForm.controls['registrationunit'].setValue(this.slideadjustmentunitpriceBasicInfo.registrationunit);
        this.slideTankatableBasicInfoForm.controls['companyname'].setValue(this.slideadjustmentunitpriceBasicInfo.companyname);
        this.slideTankatableBasicInfoForm.controls['energyClsname'].setValue(this.slideadjustmentunitpriceBasicInfo.energyClsname);
        this.slideTankatableBasicInfoForm.controls['lpSalfrmAname'].setValue(this.slideadjustmentunitpriceBasicInfo.lpSalfrmAname);
        this.slideTankatableBasicInfoForm.controls['slideadjustmentunitpriceMemo'].setValue(this.slideadjustmentunitpriceBasicInfo.slideadjustmentunitpriceMemo);
    }

    /** 
     * 破棄処理
     * @memberof Sgkc032dTankaTableBasicInfoComponent
     */
    ngOnDestroy(): void {
        this.parentForm.clearValidators();
        this.parentForm.updateValueAndValidity();
        this.parentForm.removeControl('slideTankatableBasicInfoForm');
    }
}

